import React from "react";
import { Text, Provider } from "@fluentui/react-northstar";
import PropTypes from "prop-types";

const TitleContentComponent = (props) => {
  const { title, component, testId } = props;

  return (
    <Provider.Consumer
      render={(theme) => (
        <div className={"my-section-container " + theme.siteVariables.themeString} data-testid={testId}>
          <Text
            size="larger"
            weight="semibold"
            className="title"
            data-testid={testId + "Title"}
          >
            {title}
          </Text>
          {component}
        </div>
      )}
    ></Provider.Consumer>
  );
};

TitleContentComponent.propTypes = {
  title: PropTypes.string,
  testId: PropTypes.string,
};

TitleContentComponent.defaultProps = {
  title: "",
  testId: "",
};

export default TitleContentComponent;
